import { z } from 'zod';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const staffInviteSearchSchema = z.object({
  assignment_id: z.string().optional(),
});

type StaffInviteSearchInput = z.infer<typeof staffInviteSearchSchema>;

export interface StaffInviteRouteSearch {
  assignment_id?: string;
}

export function normalizeStaffInviteSearch(search: StaffInviteSearchInput): StaffInviteRouteSearch {
  const assignmentId =
    search.assignment_id && UUID_REGEX.test(search.assignment_id)
      ? search.assignment_id
      : undefined;

  return {
    assignment_id: assignmentId,
  };
}

export function areStaffInviteSearchEqual(
  a: StaffInviteSearchInput,
  b: StaffInviteRouteSearch,
) {
  return a.assignment_id === b.assignment_id;
}
